import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AlertErrorDialogComponent } from 'app/common/alert-error-dialog/alert-error-dialog.component';
import { AlertDialogComponent } from 'app/common/alert-dialog/alert-dialog.component';
import { AuthService } from '../../@bya/auth/services/authentication.service';


export class ByaHttp {
    baseUrl: string;

	constructor(
		protected dialog: MatDialog,
		protected authService: AuthService,
    ) {
        this.baseUrl = document.getElementsByTagName('base')[0].href;
    }

    protected handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
			if (error.status == "401") {
                this.dialog.open(AlertDialogComponent,{data:{mensaje:'401 - Tu sesión se ha vencido'}}).addPanelClass('alert');
				this.authService.signinSilent();
                window.location.href = `${this.baseUrl}login`;
			}
			if (error.status == "403") {
				//this.authService.signinSilent();
				//alert('NO ESTA AUTORIZADO A ESE RECURSO+403');
                this.dialog.open(AlertDialogComponent,{data:{mensaje:'403 - Acceso no autorizado'}}).addPanelClass('alert');
				window.location.href = `${this.baseUrl}login`;
			}

            if(error.status == "500"){
                this.mostrarError500(error);
            }

            if(error.status == "400"){
                this.mostrarError400(error);
            }

            // // this.openAlertDialog();
            // // TODO: send the error to remote logging infrastructure
            // console.error(error); // log to console instead

            // // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // // Let the app keep running by returning an empty result.

            return of(result as T);
        };
    }

    /** Log a HeroService message with the MessageService */
    protected log(message: string) {
        //console.log(message);
        // this.messageService.add(`HeroService: ${message}`);
    }

    private mostrarError500(error: any): void{
        let dialogRef = this.dialog.open(AlertErrorDialogComponent, {
            panelClass: 'alert-error',
            data: {
                titulo: "Error",
                mensaje: `<strong>Señor(a) usuario(a)</strong>
                          <br/>${error.error.Message}
                          <br/>
                          `,
                stackTrace: error.error.StackTrace
            }
        });
    }

    private mostrarError400(error: any): void{
        let contadorValidaciones : number = 0;
        let mensajeValidaciones: string =  `<strong>Señor(a) usuario(a)</strong>
                                            <br/>${error.error.Message} <br/><br/>`;

        for(const prop in error.error.Errors){
            contadorValidaciones++;
            mensajeValidaciones += `<strong>${contadorValidaciones}. ${prop}:</strong>`;

            error.error.Errors[prop].forEach(element => {
                mensajeValidaciones += `<br/> - ${element}`;
            });

            mensajeValidaciones += `<br/>`;
        }

        this.dialog.open(AlertDialogComponent, {
            panelClass: 'alert',
            data: {
                titulo: "Atención",
                mensaje: `${mensajeValidaciones}`
            }
        });
    }

    private mostrarError400_ViejaForma(error: any): void{
        let contadorValidaciones : number = 0;
        let mensajeValidaciones : string = 
            `Señor(a) usuario(a), se han presentado algunos errores de validacion, por favor reviselos y vuelva a realizar la operación.<br/><br/>`;

        for(const prop in error.error.errors){
            contadorValidaciones++;
            mensajeValidaciones += `<strong>${contadorValidaciones}. ${prop}:</strong>`;

            error.error.errors[prop].forEach(element => {
                mensajeValidaciones += `<br/> - ${element}`;
            });

            mensajeValidaciones += `<br/>`;
        }

        let dialogRef = this.dialog.open(AlertDialogComponent, {
            panelClass: 'alert',
            data: {
                titulo: "Atención",
                mensaje: `${mensajeValidaciones}`
            }
        });
    }
}
